"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const player_1 = __importDefault(require("@vimeo/player"));
const react_1 = require("react");
const OkayVimeoCore = (props) => {
    const [player, setPlayer] = react_1.useState(null);
    const [duration, setDuration] = react_1.useState(0);
    const init = () => {
        const p = new player_1.default('_vimeo', { url: props.src, controls: false, muted: !props.speckerOn });
        let prevTime = null;
        p.on('timeupdate', (time) => {
            const newTime = {
                seconds: Math.round(time.seconds * 100) / 100,
                percent: Math.round(time.percent * 100),
                duration: Math.round(time.duration * 100) / 100,
            };
            if (time.duration !== duration)
                setDuration(time.duration);
            if (JSON.stringify(prevTime) === JSON.stringify(newTime))
                return;
            prevTime = newTime;
            p.getPaused().then((isPaused) => {
                if (isPaused)
                    return;
                props.onProgressChanged(newTime, props.id);
            });
        });
        p.on('loaded', () => {
            p.getDuration().then((newDuration) => {
                setDuration(newDuration);
                props.onProgressChanged({ duration: newDuration, seconds: 0, percent: 0 }, props.id);
            });
        });
        p.on('playing', () => {
            props.onIsPlayingChanged(true, props.id);
        });
        p.on('pause', () => {
            props.onIsPlayingChanged(false, props.id);
        });
        p.on('volumechange', (volume) => {
            p.getMuted().then((isMuted) => {
                props.onSpeakerOnChanged(!isMuted, props.id);
            });
        });
        p.on('ended', () => {
            props.onEnded ? props.onEnded() : null;
        });
        setPlayer(p);
    };
    react_1.useEffect(() => {
        if (!props.id)
            return;
        if (player) {
            player.destroy().then(() => {
                setPlayer(null);
                init();
            });
        }
        else {
            init();
        }
    }, [props.id, props.src]);
    react_1.useEffect(() => {
        if (!player)
            return;
        if (props.isPlaying) {
            player === null || player === void 0 ? void 0 : player.play().catch(e => { });
        }
        else {
            player === null || player === void 0 ? void 0 : player.pause();
        }
    }, [props.isPlaying]);
    react_1.useEffect(() => {
        if (!player)
            return;
        if (props.speckerOn) {
            player.setMuted(false);
        }
        else {
            player.setMuted(true);
        }
    }, [props.speckerOn]);
    react_1.useEffect(() => {
        if (!player)
            return;
        player.setCurrentTime(props.targetCurrent > duration ? duration : props.targetCurrent);
    }, [props.targetCurrent]);
    return props.id ? (React.createElement("div", { dangerouslySetInnerHTML: { __html: '<style>._vimeo iframe{width:100%;height:100%;background-color: #000;}</style>' }, style: { width: '100%', height: '100%' }, className: "_vimeo", id: "_vimeo" })) : null;
};
exports.default = OkayVimeoCore;
//# sourceMappingURL=OkayVimeoCore.js.map